import React from 'react'
import { useTranslation } from 'react-i18next'
import { Router } from 'react-router-dom'
import { createBrowserHistory } from 'history'

import ErrorBoundary from '@Core/Components/ErrorBoundary'
import ErrorView from '@Core/Components/ErrorView'
import ContextProvider from '@Context'
import Routes from 'Routes'

export const customHistory = createBrowserHistory()

const App = (props) => {
  const { t, i18n } = useTranslation()

  return (
    <ErrorBoundary render={() => <ErrorView />}>
      <ContextProvider>
        <Router history={customHistory}>
          <Routes />
        </Router>
      </ContextProvider>
    </ErrorBoundary>
  )
}

export default App
